import { Component, OnInit } from '@angular/core';
import { AuthSession } from '@navify-platform/auth';
import { NavifyService } from 'src/app/auth/services/navify.service';
import { LabelService } from 'src/app/shared/services/label.service';
import { EnclaveService } from 'src/app/shared/services/enclave.service';
import { SnackBarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-app-lobby',
  templateUrl: './app-lobby.component.html',
  styleUrls: ['./app-lobby.component.scss'],
  standalone: false
})
export class AppLobbyComponent implements OnInit {
  i18n = this.labelService.labels;
  sessionInfo!: AuthSession;
  isDownloading: boolean = false;
  links: string[] = [
  ]

  constructor(
    private readonly nanvifyService: NavifyService,
    private readonly labelService: LabelService,
    private readonly snackBarService: SnackBarService,
    private readonly service: EnclaveService
  ) { }

  ngOnInit() {
    this.sessionInfo = this.nanvifyService.sessionInfo
  }

  downloadDocumentation(): void {
    this.isDownloading = true;
    this.service.getUserManualDetails().subscribe({
      next: (response) => {
        this.isDownloading = false;
        if (response?.result?.length > 0) {
          window.open(response.result[0], '_blank');
        }
      },
      error: (error) => {
        this.snackBarService.displaySnackBar(
            this.i18n.TOAST.TECHNICAL_ERR, 'warning');
        this.isDownloading = false;
      }
    });
  }

}
